import {logAnalytics} from "../utils/firebase-util";
const CardX = ({title, image, url, text, name, disabled}) => {
    return (
        <div className="max-w-sm rounded overflow-hidden shadow-lg mt-4 mb-4 pb-16 md:ml-4">
            <a className={`${disabled ? "pointer-events-none" : ""}`} href={url} target="_blank" rel="noreferrer" onClick={() => logAnalytics(name)}>
            <img className="w-3/4 h-3/4 place-content-center md:w-72 md:h-56" src={image} alt={name} />
                <div className="px-6 py-4">
                    <div className="font-bold text-xl mb-2">{title}</div>
                    <p className="text-gray-700 w-50 text-base break-words">
                        {text}
                    </p>
                </div>
            </a>
        </div>
    );
}

export default CardX;